import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NbThemeModule, NbLayoutModule, NbCardModule, NbButtonModule, NbIconModule, NbDialogModule, NbInputModule, NbSelectModule } from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NavComponent } from './components/shared/nav/nav.component';
import { ErrorpageComponent } from './components/shared/errorpage/errorpage.component';
import { HomeComponent } from './components/pages/home/home.component';
import { AboutComponent } from './components/pages/about/about.component';
import { WorksComponent } from './components/pages/works/works.component';
import { LoginComponent } from './components/pages/login/login.component';
import { EditpageComponent } from './components/pages/editpage/editpage.component';
import { AuthService } from './services/auth.service';
import { AuthguardService } from './services/authguard.service';
import { HttpClientModule } from '@angular/common/http';
import { EditpaintingsComponent } from './components/pages/editpaintings/editpaintings.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ConfirmboxComponent } from './components/shared/confirmbox/confirmbox.component';
import { NewPaintingComponent } from './components/pages/new-painting/new-painting.component';
import { PaintingComponent } from './components/pages/painting/painting.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { PaintingService } from './services/painting.service';
import { ContactService } from './services/contact.service';
import { UserService } from './services/user.service';


@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    ErrorpageComponent,
    HomeComponent,
    AboutComponent,
    WorksComponent,
    LoginComponent,
    EditpageComponent,
    EditpaintingsComponent,
    ConfirmboxComponent,
    NewPaintingComponent,
    PaintingComponent,
    ContactComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NbThemeModule.forRoot({ name: 'cosmic' }),
    NbLayoutModule,
    NbEvaIconsModule,
    NbCardModule,
    NbButtonModule,
    NbEvaIconsModule,
    NbIconModule,
    NbInputModule,
    NbSelectModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NbDialogModule.forRoot(),
  ],
  providers: [AuthService, AuthguardService,PaintingService,ContactService,UserService],
  bootstrap: [AppComponent],
})
export class AppModule {}
